import { MenuItemBaseComponent } from './../../../../common-theme/base-components/shared/menu/menu-item-base/menu-item-base.component';
import { Component } from '@angular/core';
import { MenuLink } from '../../../../common-theme/base-components/shared/menu/menu-link.model';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: [
    './menu-item.component.scss',
    '../../../../common-theme/base-components/shared/menu/menu-item-base/menu-item-base.component.scss'
  ]
})

export class MenuItemComponent extends MenuItemBaseComponent {
  public isItemLinkActive(item: MenuLink, children: MenuLink[]): boolean {
    if (item.link === this.currentRoute)
      return true;
    else if (this.currentRoute.includes(item.link) && item.link !== '/')
      return true;

    // TODO: should find a better way
    if (
      this.currentRoute.includes('/romanescu-lifestyle/') &&
      item.link === '/romanescu-lifestyle/concept')
      return true

    if (children.length > 0)
      if (children.find((child) => this.currentRoute.includes(child.link)))
        return true;

    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/menu/menu-item/menu-item.component.ts